import React, { PureComponent as Component } from 'react';
import {
  Card,
  CardText,
  Row,
  Col
} from 'reactstrap';
import propTypes from 'prop-types';
import PaymentSummaries from './details/PaymentSummaries';
import GeneralInfo from './details/GeneralInfo';

export default class Details extends Component {
  render(){
    const { isLoading, order, seller, shipping, productConsignment } = this.props;
    return(
      <Card body className={this.props.className}>
        <CardText>Your Consignment Order Detail.</CardText>
        <Row>
          <Col xs={12} md={6}>
            <GeneralInfo
              isLoading={isLoading}
              order={order}
              seller={seller}
              shipping={shipping}
              productConsignment={productConsignment}
            />
          </Col>
          <Col xs={12} md={6}>
            <PaymentSummaries
              isLoading={isLoading}
              order={order}
            />
          </Col>
        </Row>
      </Card>
    )
  }
}
Details.propTypes= {
  isLoading: propTypes.bool,
  order: propTypes.object,
  shipping: propTypes.object,
  seller: propTypes.object
}
Details.defaultProps = {
  isLoading: false
}